<template>
<AppLayout>
    <div class="home">
        <section id="settings-users">
        <div class="container">
            <div class="panel">
                <h6 for="" class="fw-bold">1. User Documents</h6>
                <div class="row mt-1">
                    <div class="col-md-4">
                        <label for="address">Passport Picture</label><br>
                        <img v-if="selectedUploadPicturePreview" :src="selectedUploadPicturePreview" alt="Selected picture preview" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <img v-else-if="currentUploadPicture" :src="fileUrl(currentUploadPicture)" alt="Uploaded picture" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <input type="file" class="form-control" ref="filePicture" @change="handleFileChange" placeholder="Upload a new file" style="float: left; width: 80%;">
                        <button class="btn btn-sm btn-primary" @click="postDocument('picture')" style="float: left; margin: 2px 0px 0px 10px;">Upload</button>
                    </div>
                    <div class="col-md-4">
                        <label for="address">User ID</label><br>
                        <img v-if="selectedUploadPreview" :src="selectedUploadPreview" alt="Selected ID preview" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <img v-else-if="currentUpload" :src="fileUrl(currentUpload)" alt="Uploaded ID" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <input type="file" class="form-control" ref="fileUpload" @change="handleFileChange" placeholder="Upload a new file" style="float: left; width: 80%;">
                        <button class="btn btn-sm btn-primary" @click="postDocument('upload')" style="float: left; margin: 2px 0px 0px 10px;">Upload</button>
                    </div>
                    <div class="col-md-4">
                        <label for="address">Signature</label><br>
                        <img v-if="selectedUploadSignaturePreview" :src="selectedUploadSignaturePreview" alt="Selected signature preview" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <img v-else-if="currentUploadSignature" :src="fileUrl(currentUploadSignature)" alt="Uploaded signature" style="max-height: 225px; max-width: 500px;margin-bottom: 10px;">
                        <input type="file" class="form-control" ref="fileSignature" @change="handleFileChange" placeholder="Upload a new file" style="float: left; width: 80%;">
                        <button class="btn btn-sm btn-primary" @click="postDocument('signature')" style="float: left; margin: 2px 0px 0px 10px;">Upload</button>
                    </div>
                </div>
                <hr>
                <h6 for="" class="fw-bold">2. Edit user</h6>
                <div class="row mt-1">
                  
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="address">System Role</label>
                        <select v-model="roleId" class="full form-control" id="roles"  v-if="roles.length > 0">
                            <option v-for="role in roles" v-bind:Key="role.id" :value="role.id">
                                {{ role.name }}
                            </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3">
                        <label for="">Name</label>
                        <input type="text"  class="form-control" v-model="name" >
                    </div>
                    <div class="col-md-3">
                        <label for="">Designation</label>
                        <input type="text"  class="form-control" v-model="designation" >
                    </div>
                    <div class="col-md-3">
                        <label for="">Employee Id No.</label>
                        <input type="text"  class="form-control" v-model="employeeId" >
                    </div>
                    <div class="col-md-3">
                        <label for="">Mobile Contact No. 1</label>
                        <input type="text" placeholder="Use +2547... (format)"  class="form-control" v-model="phone" >
                    </div>
                    <div class="col-md-3">
                        <label for="">Mobile Contact No. 2</label>
                        <input type="text" placeholder="Use +2547... (format)"  class="form-control" v-model="phone2" >
                    </div>
                    <div class="col-md-3">
                        <label for="">Email Address</label>
                        <input type="email"  class="form-control" v-model="email" >
                    </div>
                    <div class="col-md-2">
                        <div class="check-button">
                        <div class="form-group">
                            <label>System User?</label>
                            <div class="components-button">
                        <span class="switcher switcher-1">
                            <input type="checkbox" id="switcher-1" v-model="isSystemUser">
                            <label for="switcher-1"></label>
                        </span>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="col-md-1" style="margin-left:-20px">
                        <button class="btn btn-style btn-small" @click="postUser" style="margin-top: 23px;">Update</button>
                    </div>
                </div>
            </div>

        </div>
    </section>
    </div>
</AppLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import AppLayout from '../../components/AppLayout.vue';
export default {
    name: 'SettingsUser',
    components:{
        AppLayout
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        urlServer:process.env.VUE_APP_URL,
        userId:"",
        user:"",
        name: "",
        email: "",
        phone: "",
        roleId:"",
        isSystemUser:true,
        designation:"",
        employeeId : "",
        phone2:"",
        uploadSignature:"",
        uploadPicture:"",
        upload:"",
        currentUploadSignature:"",
        currentUploadPicture:"",
        currentUpload:"",
        selectedUploadPreview: '',
        selectedUploadPicturePreview: '',
        selectedUploadSignaturePreview: '',
        loading: false
    }),
    computed:{
        ... mapGetters (["getRoles"]),
        roles () { return this.getRoles },
    },
    methods:{
        ... mapActions(['fetchRoles']),
        async postUser () {
            let formData = new FormData()
            formData.append("name", this.name)
            // only append files when selected
            if (this.upload) formData.append("upload", this.upload)
            if (this.uploadPicture) formData.append("picture", this.uploadPicture)
            if (this.uploadSignature) formData.append("signature", this.uploadSignature)
            formData.append("designation", this.designation)
            formData.append("employeeId", this.employeeId)
            formData.append("isSystemUser", this.isSystemUser)
            formData.append("roleId", this.roleId)
            formData.append("email", this.email)
            formData.append("phone", this.phone)
            formData.append("phone2", this.phone2)
            const requestOptions = {
                method: "PATCH",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
                body:formData
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/'+this.userId, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User Details updated',
                    text: data.message
                })
                this.$router.back()
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'User not updated',
                    text: data.message
                })
            }
        },
        async postDocument (type) {
            // ensure a file is selected before attempting upload
            if (type === 'upload' && !this.upload) {
                Swal.fire({ icon: 'error', title: 'No file selected', text: 'Please choose a file to upload' });
                return;
            }
            if (type === 'picture' && !this.uploadPicture) {
                Swal.fire({ icon: 'error', title: 'No picture selected', text: 'Please choose a picture to upload' });
                return;
            }
            if (type === 'signature' && !this.uploadSignature) {
                Swal.fire({ icon: 'error', title: 'No signature selected', text: 'Please choose a signature file to upload' });
                return;
            }

            let formData = new FormData()
            formData.append("name", this.name)
            if(type =="upload") {
             formData.append("file", this.upload)
            }
            if(type =="picture") {
            formData.append("file", this.uploadPicture)
            }
            if(type =="signature") {
            formData.append("file", this.uploadSignature)
            }
            const requestOptions = {
                method: "POST",
                headers: { 
                  'Accept': 'application/json',
                  'Authorization': 'Bearer '+this.token 
                },
                body:formData
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/'+this.userId+'/'+type, requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                    icon: 'success',
                    title: 'User Documents updated',
                    text: data.message
                })
                this.setupUser(this.userId)
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'User not updated',
                    text: data.message
                })
            }
        },
        async setupUser(itemId){
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };
            const res = await fetch(process.env.VUE_APP_URL+'/users/'+itemId, requestOptions)
            const data = await res.json()
            if(data.status == true){
                this.user = data.user;
                this.userId= data.user.id;
                this.name= data.user.name;
                this.email= data.user.email;
                this.phone= data.user.phone;
                this.roleId= data.user.permissionId;
                this.isSystemUser= data.user.isSystemUser;
                this.designation= data.user.designation;
                this.employeeId= data.user.employeeId;
                this.phone2= data.user.phone2;
                const sanitize = (v) => (v && v !== 'null' && v !== 'undefined' ? v : '');
                this.currentUploadSignature= sanitize(data.user.signature);
                this.currentUploadPicture= sanitize(data.user.picture);
                this.currentUpload= sanitize(data.user.uploadId);
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'User not found. Try again',
                    text: data.message
                })
            }
        },

        fileUrl(path) {
            if (!path) return '';
            // if already a full URL
            if (String(path).startsWith('http')) return path;
            // normalize and split
            const p = String(path).replace(/^\//, '');
            const parts = p.split('/');
            if (parts.length === 1) {
                // unknown folder, return as-is under files
                return `${this.urlServer}/files/${parts[0]}`;
            }
            const folder = parts[0];
            const file = parts.slice(1).join('/');
            return `${this.urlServer}/files/${folder}/${file}`;
        },

        handleFileChange() {
                    // revoke previous previews to avoid memory leaks
                      try { if (this._prevUploadPreview) URL.revokeObjectURL(this._prevUploadPreview); } catch (e) { console.warn('Failed to revoke previous upload preview', e); }
                      try { if (this._prevPicturePreview) URL.revokeObjectURL(this._prevPicturePreview); } catch (e) { console.warn('Failed to revoke previous picture preview', e); }
                      try { if (this._prevSignaturePreview) URL.revokeObjectURL(this._prevSignaturePreview); } catch (e) { console.warn('Failed to revoke previous signature preview', e); }

                    const file = this.$refs.fileUpload?.files[0];
                    const sig = this.$refs.fileSignature?.files[0];
                    const pic = this.$refs.filePicture?.files[0];

                    if (file) {
                        this.upload = file;
                        this.selectedUploadPreview = URL.createObjectURL(file);
                        this._prevUploadPreview = this.selectedUploadPreview;
                    } else {
                        this.upload = undefined;
                        this.selectedUploadPreview = '';
                    }

                    if (sig) {
                        this.uploadSignature = sig;
                        this.selectedUploadSignaturePreview = URL.createObjectURL(sig);
                        this._prevSignaturePreview = this.selectedUploadSignaturePreview;
                    } else {
                        this.uploadSignature = undefined;
                        this.selectedUploadSignaturePreview = '';
                    }

                    if (pic) {
                        this.uploadPicture = pic;
                        this.selectedUploadPicturePreview = URL.createObjectURL(pic);
                        this._prevPicturePreview = this.selectedUploadPicturePreview;
                    } else {
                        this.uploadPicture = undefined;
                        this.selectedUploadPicturePreview = '';
                    }
        }
        
    },
    beforeUnmount(){
        try { if (this._prevUploadPreview) URL.revokeObjectURL(this._prevUploadPreview); } catch (e) { console.warn('Failed to revoke upload preview on unmount', e); }
        try { if (this._prevPicturePreview) URL.revokeObjectURL(this._prevPicturePreview); } catch (e) { console.warn('Failed to revoke picture preview on unmount', e); }
        try { if (this._prevSignaturePreview) URL.revokeObjectURL(this._prevSignaturePreview); } catch (e) { console.warn('Failed to revoke signature preview on unmount', e); }
    },
    mounted(){
        this.fetchRoles()
        this.userId = this.$route.params.id
        this.setupUser(this.userId)
    }
}
</script>

<style lang="scss" scoped>
input {
    border: 1px solid #b4c7e7;
    border-radius: 3px;
}
::placeholder{
    color: black !important;
    opacity: .7 !important;
    text-transform: none !important;
}
table{
    margin-left: 11px;
}
th, td{
    text-align: center !important;
}

$primary: #d2d2d2;
$green: #000000;
$white: #ffffff;
  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
      }
  </style>